import { WebsitesBlockedController } from '../controller/WebsitesBlockedController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class WebsitesBlockedComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: WebsitesBlockedController,
    });
  }
}
